import { Form as BaseForm, message } from 'antd';
import React, { useState } from 'react';

import { useNavigate } from 'react-router';
import { captureException } from 'utils/errors';
import ConfirmModal from './ConfirmModal';
import Form from './Form';
import { createTransaction } from './requests';

function AdjustBalance({ customer }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [form] = BaseForm.useForm();
  // const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  function handleSubmit() {
    setLoading(true);
    const values = form.getFieldsValue();
    createTransaction(customer.id, {
      ...values,
      amount: Math.round(values.amount * 100),
    }).then(() => {
      message.success('Transaction created successfully!');
      navigate(`/console/contacts/${customer.id}`);
    }).catch((e) => {
      captureException(e);
      message.error(e?.response?.data?.title ?? 'Some thing went wrong!');
    }).finally(() => setLoading(false));
  }

  return (
    <>
      <Form
        form={form}
        onSubmit={() => setConfirmOpen(true)}
        loading={loading}
      />
      <ConfirmModal
        data={form.getFieldsValue()}
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleSubmit}
      />
    </>

  );
}

export default AdjustBalance;
